import { capitaliseFirstLetter } from "@shared/translations/src";
import { removeNothings } from "@/lib/utils/arrays";

/**
 * Extracts and capitalizes error messages from various error types
 */
export const getErrorMessage = (error: unknown) => {
  if (error instanceof Error) return capitaliseFirstLetter(error.message) || "";
  if (hasErrorMessage(error)) return capitaliseFirstLetter(error.message) || "";
  return capitaliseFirstLetter(String(error));
};

/**
 * Type guard to check if an object has a message property of type string
 */
const hasErrorMessage = (error: unknown): error is { message: string } => {
  return typeof error === "object" && error !== null && "message" in error && typeof error.message === "string";
};

/**
 * Extracts and combines error messages from a single error or array of errors
 */
export const extractErrorMessages = (errors: unknown) => {
  if (Array.isArray(errors)) {
    return errors.map(getErrorMessage).join(", ");
  }

  return getErrorMessage(errors);
};

/**
 * Combines the messages of GraphQL payload field errors (`ErrorType`) into one string.
 * These are the validation errors a mutation returns in its payload, not GraphQL errors.
 */
export const extractPayloadErrorMessages = (
  errors: ReadonlyArray<{ field: string; messages: ReadonlyArray<string> } | null | undefined> | null | undefined,
) =>
  removeNothings([...(errors ?? [])])
    .flatMap((error) => error.messages)
    .map(capitaliseFirstLetter)
    .join(", ");
